import {NiButton, NiInput, NiIcon, NiLine} from "@/ni-ui"

export default {
  name: "dept-form-header",
  components: {
    NiButton,
    NiInput,
    NiIcon,
    NiLine
  },
  props: {
    dept_id: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "#cms_zuzhi3"
    },


    headerTitle: {
      type: String,
      default() {
        return "部门"
      }
    },

    tab_show: {
      type: Boolean,
      default: true
    },

    only_edit: {
      type: Boolean,
      default: false
    },

    target_tab: {
      type: String,
      default: "dept_info"
    },
    superSearchWidth: {
      default: 150,
    },
    showRight: {
      type: Boolean,
      default: true
    },
    showSupper: {
      type: Boolean,
      default: true,
    },

    showMore: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var li_icon_style = {width: '1.3em', height: '1.3em'};

    return {
      tab_op: [
        {
          name: "dept_info",
          title: "部门信息",
          fn: "show_dept_info",
        },
        {
          name: "subordinate_dept",
          title: "下级部门",
          fn: "show_subordinate_dept",
        },
        {
          name: "human_resource",
          title: "人力资源",
          fn: "show_human_resource",
        },
      ],

      btn_op: [
        {
          name: "add_equal",
          title: "新建同级部门",
          icon: "#cms_yh",
          icon_style: li_icon_style,
          fn: "add_equal",
        },
        {
          name: "add_subordinate",
          title: "新建下级部门",
          icon: "#cms_yh",
          icon_style: li_icon_style,
          fn: "add_subordinate",
        },
        {
          name: "move_user_batch",
          title: "人员批量移动",
          icon: "#cms_yh",
          icon_style: li_icon_style,
          fn: "move_user_batch",
        },
        {
          name: "edit_dept",
          title: "编辑",
          icon: "#cms_zhongmingming",
          icon_style: li_icon_style,
          fn: "edit_dept",
        },
        {
          name: "save_edit",
          title: "保存",
          icon: "#cms_queding2",
          icon_style: li_icon_style,
          fn: "save_edit",
        },
        {
          name: "del_dept",
          title: "删除",
          icon: "#cms_shanchu",
          icon_style: li_icon_style,
          fn: "del_dept",
        },
      ],

      current_tab: "",

      // btn_op_more: [
      //   {
      //     name: "del_dept",
      //     title: "删除",
      //     icon: "",
      //     fn: "del_dept",
      //   },
      // ],

    }
  },
  mounted() {
    this.current_tab = this.target_tab

  },

  computed: {},

  watch: {
    current_tab(val) {
      this.$emit("tab_change", val)
    },
  },

  methods: {
    show_back(show) {
      this.$emit("show_back", show)
    },

    // 头部按钮栏按钮执行
    operationFn(item) {
      // 如果不可点击 return
      // if(!item.status) return false;
      this[item.fn]();

    },

    handle_click_tab(tab) {
      this.current_tab = tab
    },

    move_user_batch() {
      this.$emit("move_user_batch")
    },

    save_edit() {
      this.$emit("save_edit")
    },

    edit_dept() {
      this.$emit("edit_dept")
    },

    add_equal() {
      this.$emit("add_equal")
    },

    add_subordinate() {
      this.$emit("add_subordinate")
    },

    del_dept() {
      this.$emit("del_dept")
    },

  },
}



// WEBPACK FOOTER //
// ./src/omnis-business/form-header/form-header.js